import { useNavigate, useLocation } from 'react-router-dom';
import { Activity, Clock, User, Settings as SettingsIcon, ClipboardList, Mic } from 'lucide-react';
// Removed floating ActiveWorkoutPill — was distracting on mobile.
import CasePowerPill from './CasePowerPill';

export default function TopNav({ workoutActive = false, onEndSession }) {
  const navigate = useNavigate();
  const location = useLocation();
  
  const isActive = (path) => location.pathname === path;
  
  const navItems = [
    { path: '/dashboard', icon: Activity, label: 'Monitor' },
    { path: '/programs', icon: ClipboardList, label: 'Programs' },
    { path: '/history', icon: Clock, label: 'History' },
    { path: '/coxswain', icon: Mic, label: 'Coxswain' },
    { path: '/profile-setup', icon: User, label: 'Profile' },
    { path: '/devices', icon: SettingsIcon, label: 'Settings' },
  ];

  const handleLogoClick = () => {
    if (workoutActive) {
      // Session in progress - confirm before leaving
      const confirmed = window.confirm('Are you sure you want to finish this session?');
      if (confirmed) {
        if (onEndSession) {
          onEndSession();
        }
        navigate('/');
      }
    } else {
      // No session - go directly to boat selection
      navigate('/');
    }
  };

  return (
    <div className="bg-white dark:bg-zinc-800 border-b-2 border-zinc-200 dark:border-zinc-700 px-2 sm:px-4 py-3 transition-colors" data-testid="top-nav">
      <div className="max-w-7xl mx-auto flex items-center min-w-0">
        {/* Logo - Clickable to go to Boat Selection */}
        <button 
          onClick={handleLogoClick}
          className="flex items-center gap-2 mr-2 sm:mr-6 shrink-0 hover:opacity-80 transition-opacity"
          data-testid="logo-home"
        >
          {/* CrewZ brand logo: icon only on phones, full wordmark from sm up */}
          <img src="/crewz-logo-light-icon.png" alt="CrewZ" className="h-9 w-9 sm:hidden dark:hidden" data-testid="crewz-logo-icon" />
          <img src="/crewz-logo-dark-icon.png" alt="CrewZ" className="h-9 w-9 hidden dark:block dark:sm:hidden" data-testid="crewz-logo-icon-dark" />
          <img src="/crewz-logo-light.png" alt="CrewZ" className="hidden sm:block dark:sm:hidden h-9 w-auto" data-testid="crewz-logo" />
          <img src="/crewz-logo-dark.png" alt="CrewZ" className="hidden dark:sm:block h-9 w-auto" data-testid="crewz-logo-dark" />
        </button>
        {/* CrewZ case battery + phone-charging indicator */}
        <CasePowerPill />
        {/* Nav Items */}
        <div className="flex-1 min-w-0 flex justify-around items-center">
          {navItems.map((item) => (
            <button 
              key={item.path}
              onClick={() => navigate(item.path)} 
              className={`flex flex-col items-center gap-1 min-w-0 flex-1 sm:flex-none transition-colors ${isActive(item.path) ? 'text-zinc-900 dark:text-white' : 'text-zinc-400 dark:text-zinc-500 hover:text-zinc-600 dark:hover:text-zinc-300'}`}
              data-testid={`nav-${item.label.toLowerCase()}`}
            >
              <item.icon className="w-5 h-5 sm:w-6 sm:h-6" />
              <span className="text-[8px] sm:text-xs font-bold uppercase tracking-tight sm:tracking-wider leading-none max-w-full truncate">{item.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
